import { getI18n } from 'react-i18next';

import { KEY_TRANSLATE_LANGUAGE } from '@/constant';
import { useLanguageOptions } from '@/hooks/useLangues';
import { useMemo } from 'react';

export const useGetLanguageInfo = () => {
  const i18n = getI18n();
  const languageOptions = useLanguageOptions();
  const lang = localStorage.getItem(KEY_TRANSLATE_LANGUAGE);
  const langSelected = languageOptions.find((option) => option.value === (lang || i18n.language));

  const languageOnChange = (val: string | null) => {
    if (!val) return;
    i18n.changeLanguage(val);
    localStorage.setItem(KEY_TRANSLATE_LANGUAGE, val);
    document.documentElement.lang = val;
  };

  const voiceLanguage = useMemo(() => langSelected?.value.substring(0, 2), [langSelected]);

  return {
    languageOptions,
    langSelected,
    languageOnChange,
    voiceLanguage,
  };
};
